import React from 'react';
import { XAxis, YAxis, LineChart, Line, ResponsiveContainer, Tooltip, ReferenceLine } from 'recharts';
import { connect } from 'react-redux';
import { LinearProgress, Divider, RaisedButton, Snackbar } from 'material-ui';
import moment from 'moment';
import req from 'superagent';
import _ from 'lodash';
import humanize from 'humanize-string';
import { getEntities, getQueries } from 'dash-front/selectors';
import { fetchPostPredictions } from 'dash-front/campaign/actions/predictions';
import { fetchCampaignById } from 'dash-front/campaign/actions/campaigns';
import { fetchEventById } from 'dash-front/actions/events';
import auth from 'dash-front/auth';
import cfg from 'cfg';

const EventLabel = connect(
    (state, { eventId }) => ({
        event: _.get(getEntities(state), 'events.' + eventId),
        pending: _.get(getQueries(state), '[events/' + eventId + '].isPending', true)
    }),
    dispatch => ({
        fetchEvent: eventId => dispatch(fetchEventById(eventId))
    })
)(
    class _EventLabel extends React.PureComponent {
        componentDidMount() {
            const { eventId, fetchEvent } = this.props;
            if (eventId) {
                fetchEvent(eventId);
            }
        }

        componentWillReceiveProps({ eventId, event }) {
            if (this.props.eventId !== eventId && eventId) {
                this.props.fetchEvent(eventId);
            }
        }

        render() {
            const { event, pending } = this.props;
            const label = event ? 'Event: ' + event.homeShortName + ' - ' + event.awayShortName : '';
            return <div>{pending ? <LinearProgress /> : label}</div>;
        }
    }
);

const TooltipContent = ({ label, payload, byDate, rules }) => {
    const date = moment(label);
    const items = _.get(byDate, date.format('YYYY/MM/DD HH'), []);
    return (
        <div
            style={{
                backgroundColor: 'white',
                minWidth: 200,
                minHeight: 200,
                border: '1px solid #ccc'
            }}
        >
            <h4 style={{ textAlign: 'center' }}>
                {date.format('DD MMMM HH:00')}-{date
                    .clone()
                    .add(1, 'h')
                    .format('HH:00')}
            </h4>
            <div>
                {Array.isArray(payload)
                    ? payload.map(el => (
                          <p key={el.dataKey} style={{ padding: 12 }}>
                              {el.name}: {el.value}
                          </p>
                      ))
                    : null}
                {items.map((el, index) => {
                    const eventId = _.get(el, 'meta.eventId');
                    return (
                        <div key={index}>
                            <Divider />
                            <div style={{ padding: 12, marginTop: 4 }}>
                                {moment(el.date).format('HH:mm')}{' '}
                                {humanize(_.get(rules, el.ruleId + '.triggerType', ''))}
                                {eventId ? <EventLabel eventId={eventId} /> : null}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const mapPredictions = predictions => {
    if (!predictions || !predictions.length) {
        return {
            byDate: {},
            data: []
        };
    }
    const today = moment().startOf('d');
    const lastDate = moment(_.last(predictions).date);
    const hoursDiff = lastDate.diff(today, 'h');
    const byDate = predictions.reduce((acc, cur) => {
        const date = moment(cur.date).format('YYYY/MM/DD HH');
        if (acc[date]) {
            acc[date].push(cur);
        } else {
            acc[date] = [cur];
        }
        return acc;
    }, {});
    return {
        byDate,
        data: _.times(hoursDiff).map(hoursQuantity => {
            const curDate = today.clone().add(hoursQuantity, 'h');
            const formatted = curDate.format('YYYY/MM/DD HH');
            const curPredictions = Array.isArray(byDate[formatted]) ? byDate[formatted] : [];
            return {
                date: curDate.format(),
                quantity: curPredictions.length
            };
        })
    };
};
const ReferenceLabel = props => {
    const { fill, value, textAnchor, fontSize, viewBox, dy, dx } = props;
    const x = viewBox.width + viewBox.x + 5;
    const y = viewBox.y + 10;
    return (
        <text x={x} y={y} dy={dy} dx={dx} fill={fill} fontSize={fontSize || 10} textAnchor={textAnchor}>
            {value}
        </text>
    );
};
class PostPredictions extends React.PureComponent {
    componentDidMount() {
        const { params, fetchPredictions, fetchCampaign } = this.props;
        fetchPredictions(params.campaignId);
        fetchCampaign(params.campaignId);
    }

    componentWillReceiveProps(props) {
        if (this.props.data !== props.data) {
            const { byDate, data } = mapPredictions(props.data);
            const now = moment()
                .hour(0)
                .second(0)
                .minute(0);
            const dates = _.times(
                moment(
                    _.get(
                        _.last(data),
                        'date',
                        now
                            .clone()
                            .add(1, 'd')
                            .format()
                    )
                ).diff(now, 'd')
            ).map(count =>
                now
                    .clone()
                    .add(count, 'd')
                    .toDate()
            );
            this.setState({ mapped: data, byDate, dates });
        }
        if (this.props.campaign !== props.campaign) {
            const rules = _.get(props.campaign, 'rules', []);
            const rulesMap = rules.reduce((acc, cur) => {
                acc[cur._id] = cur;
                return acc;
            }, {});
            this.setState({ rules: rulesMap });
        }
    }

    state = {
        mapped: [],
        byDate: {},
        rules: {},
        dates: [],
        showSnackbar: false
    };

    generatePredictions = () => {
        const { campaignId } = this.props.params;
        req
            .post(
                `${cfg.campaign_manager
                    .host}/api/campaigns/${campaignId}/predictions?access_token=${auth.getAccessToken()}`
            )
            .then(() => {
                this.setState({ showSnackbar: true });
                setTimeout(() => this.setState({ showSnackbar: false }), 3000);
            });
    };

    render() {
        const { mapped, byDate, rules, dates } = this.state;
        return (
            <div style={{ marginTop: 48 }}>
                <RaisedButton
                    onTouchTap={this.generatePredictions}
                    label={'Generate'}
                    style={{ margin: '0px 12px 16px 12px' }}
                />
                <Snackbar open={this.state.showSnackbar} message={'Sent to process'} />
                <ResponsiveContainer height={400}>
                    <LineChart data={mapped}>
                        <Tooltip isAnimationActive={false} content={TooltipContent} byDate={byDate} rules={rules} />
                        <YAxis allowDecimals={false} />
                        <XAxis
                            dataKey={'date'}
                            minTickGap={0}
                            tick={props => {
                                const date = _.get(props, 'payload.value');
                                const mom = moment(date);
                                const hours = mom.hours();
                                const text = hours === 1 ? mom.format('DD MMM') : mom.format('HH:00');
                                return (
                                    <text
                                        width={props.width}
                                        height={props.height}
                                        x={props.x}
                                        y={props.y}
                                        stroke={props.stroke}
                                        fill={props.fill}
                                        className="recharts-text recharts-cartesian-axis-tick-value"
                                        textAnchor={props.textAnchor}
                                    >
                                        <tspan x={props.x} dy="0.71em">
                                            {text}
                                        </tspan>
                                    </text>
                                );
                            }}
                        />
                        {dates.map(el => {
                            const date = moment(el);
                            const x = date.format();
                            return (
                                <ReferenceLine
                                    key={x}
                                    x={x}
                                    stroke="#666"
                                    label={<ReferenceLabel value={date.format('DD MMM')} fill={'#666'} />}
                                />
                            );
                        })}
                        <Line dataKey={'quantity'} name={'Quantity'} type={'monotone'} stroke={'#82ca9d'} dot={false} />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    }
}

export default connect(
    (state, { params }) => ({
        data: getEntities(state)[`${params.campaignId}/postPredictions`],
        campaign: _.get(getEntities(state), `campaigns.${params.campaignId}`)
    }),
    dispatch => ({
        fetchPredictions: campaignId => dispatch(fetchPostPredictions(campaignId)),
        fetchCampaign: campaignId => dispatch(fetchCampaignById(campaignId))
    })
)(PostPredictions);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/PostPredictions.js
 **/